import { RiTodoLine } from 'react-icons/ri'
import { MenuItem } from '../types'
import { BiMemoryCard } from 'react-icons/bi'
import { FaRegLightbulb } from 'react-icons/fa'
import { AiOutlineLink } from 'react-icons/ai'
import {
  MdOutlineLocalMovies,
  MdOutlineLocationOn,
  MdOutlineReportProblem,
} from 'react-icons/md'
import { PiBowlFood } from 'react-icons/pi'
import { LiaRingSolid } from 'react-icons/lia'
import { IoAirplaneOutline } from 'react-icons/io5'

const notesMenu: MenuItem[] = [
  {
    icon: RiTodoLine,
    name: 'To-Dos',
    path: '/notes/to-dos',
    code: 'to-dos',
    apiPrefixes: ['/notes'],
  },
  {
    icon: BiMemoryCard,
    name: 'Memories',
    path: '/notes/memories',
    code: 'memories',
    apiPrefixes: ['/memories'],
  },
  {
    icon: FaRegLightbulb,
    name: 'Ideas',
    path: '/notes/ideas',
    code: 'ideas',
    apiPrefixes: ['/ideas'],
  },
  {
    icon: MdOutlineLocalMovies,
    name: 'Movies',
    path: '/notes/movies',
    code: 'movies',
    apiPrefixes: ['/movies'],
  },
  {
    icon: AiOutlineLink,
    name: 'Links',
    path: '/notes/links',
    code: 'links',
    apiPrefixes: ['/link'],
  },
  {
    icon: MdOutlineLocationOn,
    name: 'Locations',
    path: '/notes/locations',
    code: 'locations',
    apiPrefixes: ['/locations'],
  },
  {
    icon: PiBowlFood,
    name: 'Food',
    path: '/notes/recipes',
    code: 'recipes',
    apiPrefixes: ['/recipes', '/menus'],
  },
  {
    icon: IoAirplaneOutline,
    name: 'Trips',
    path: '/notes/trips',
    code: 'trips',
    apiPrefixes: ['/trips'],
  },
  {
    icon: LiaRingSolid,
    name: 'Wedding',
    path: '/notes/wedding',
    code: 'wedding',
    apiPrefixes: ['/wedding-events', '/wedding/participants'],
  },
  {
    icon: MdOutlineReportProblem,
    name: 'Protocols',
    path: '/notes/protocols',
    code: 'protocols',
    apiPrefixes: ['/protocols'],
  },
]

export default notesMenu
